export const configConstants = {
  LOAD: 'CONFIG/LOAD',
  LOAD_SUCCESS: 'CONFIG/LOAD_SUCCESS',
  LOAD_FAIL: 'CONFIG/LOAD_FAIL',
  TENANT_CONFIG: 'CONFIG/TENANT_CONFIG',
};
